import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { ErrorNoTelemetry } from 'vscode/vscode/vs/base/common/errors';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { ITerminalLogService } from 'vscode/vscode/vs/platform/terminal/common/terminal.service';
import { IWorkspaceContextService } from 'vscode/vscode/vs/platform/workspace/common/workspace.service';
import { ITerminalInstanceService } from 'vscode/vscode/vs/workbench/contrib/terminal/browser/terminal.service';
import { BaseTerminalProfileResolverService } from '../browser/terminalProfileResolverService.js';
import { ITerminalProfileService } from 'vscode/vscode/vs/workbench/contrib/terminal/common/terminal.service';
import { IConfigurationResolverService } from 'vscode/vscode/vs/workbench/services/configurationResolver/common/configurationResolver.service';
import { IHistoryService } from 'vscode/vscode/vs/workbench/services/history/common/history.service';
import { IRemoteAgentService } from 'vscode/vscode/vs/workbench/services/remote/common/remoteAgentService.service';

let ElectronTerminalProfileResolverService = class ElectronTerminalProfileResolverService extends BaseTerminalProfileResolverService {
    constructor(configurationResolverService, configurationService, historyService, logService, workspaceContextService, terminalProfileService, remoteAgentService, terminalInstanceService) {
        super({
            getDefaultSystemShell: async (remoteAuthority, platform) => {
                const backend = await terminalInstanceService.getBackend(remoteAuthority);
                if (!backend) {
                    throw ( new ErrorNoTelemetry(
                        `Cannot get default system shell when there is no backend for remote authority '${remoteAuthority}'`
                    ));
                }
                return backend.getDefaultSystemShell(platform);
            },
            getEnvironment: async (remoteAuthority) => {
                const backend = await terminalInstanceService.getBackend(remoteAuthority);
                if (!backend) {
                    throw ( new ErrorNoTelemetry(
                        `Cannot get environment when there is no backend for remote authority '${remoteAuthority}'`
                    ));
                }
                return backend.getEnvironment();
            }
        }, configurationService, configurationResolverService, historyService, logService, terminalProfileService, workspaceContextService, remoteAgentService);
    }
};
ElectronTerminalProfileResolverService = ( __decorate([
    ( __param(0, IConfigurationResolverService)),
    ( __param(1, IConfigurationService)),
    ( __param(2, IHistoryService)),
    ( __param(3, ITerminalLogService)),
    ( __param(4, IWorkspaceContextService)),
    ( __param(5, ITerminalProfileService)),
    ( __param(6, IRemoteAgentService)),
    ( __param(7, ITerminalInstanceService))
], ElectronTerminalProfileResolverService));

export { ElectronTerminalProfileResolverService };
